<script lang="ts" setup>
import DefaultLayout from '@/components/layout/DefaultLayout.vue'
import ErrorMessage from '@/components/ErrorMessage.vue'
import { useCartStore } from '@/stores/cart'
import { useRouter } from 'vue-router'
import type { AuthenticatedEntity } from '@/stores/auth'

const router = useRouter()
const cartStore = useCartStore()

defineProps<{
  authedUser?: AuthenticatedEntity
}>()
</script>

<template>
  <DefaultLayout
    :cart-count="cartStore.items.length"
    :location="'not-found'"
    :is-subscriber="authedUser ? !!authedUser.rechargeId : false"
    @back="router.back()"
    @go-to-cart="router.push('/cart')"
    @go-to-home="router.push('/')"
    @go-to-upcoming-orders="router.push('/upcoming-orders')"
    @go-to-your-products="router.push('/product-subscriptions')"
  >
    <ErrorMessage>
      <template #title>Not found</template>
      <p>The page you're trying to load does not exist.</p>
    </ErrorMessage>
  </DefaultLayout>
</template>
